<div class="table-wrapper-container">
  @if (tableHeaderRef) {
    <header class="table-header-section">
      <ng-container *ngTemplateOutlet="tableHeaderRef"></ng-container>
    </header>
  }
  @if (tableHeaderRef && tableSubHeaderRef) {
    <header class="table-subheader-section">
      <ng-container *ngTemplateOutlet="tableSubHeaderRef"></ng-container>
    </header>
  }

  @if (tableBodyRef) {
    <main class="table-body-section">
      <ng-container *ngTemplateOutlet="tableBodyRef"></ng-container>
    </main>
  }

  @if (tableFooterRef) {
    <footer class="table-footer-section">
      <ng-container *ngTemplateOutlet="tableFooterRef"></ng-container>
    </footer>
  }
</div>
